module.exports = __webpack_public_path__ + "static/media/fr.1827a83f.svg";